(function ($) {

  const $body = $('body');
  const $header = $('#site-header');
  const $menu = $('#menu-wrap');
  const $toggle = $('#mobile-menu-toggle');
  const speed = 300;

  const menu_bp = $header.data('menu-bp');

  // document.addEventListener('DOMContentLoaded', function () {
  //   const pills = document.querySelectorAll('#pills-product_info .nav-link');
  //   const dropdownItems = document.querySelectorAll('.dropdown-item');

  //   function scrollToTarget(targetId) {
  //     // const headerHeight = document.querySelector('header').offsetHeight;
  //     var $target = $(targetId);
  //     $('html, body').animate(
  //       { scrollTop: $target.offset().top },
  //       500,
  //       function () {
  //         $target.focus();
  //         if ($target.is(":focus")) {
  //           return false;
  //         } else {
  //           $target.attr('tabindex', '-1');
  //           $target.focus();
  //         }
  //       }
  //     );
  //     // document.querySelector('html, body').scrollTo({
  //     //   scrollTop: $(targetId).offset().top,
  //     //   behavior: 'smooth'
  //     // });
  //   }

  //   function activateTab(tab) {
  //     pills.forEach(p => p.classList.remove('active'));
  //     dropdownItems.forEach(item => item.classList.remove('active'));
  //     tab.classList.add('active');
  //   }

  //   pills.forEach(pill => {
  //     pill.addEventListener('click', function (e) {
  //       e.preventDefault();
  //       const targetId = this.getAttribute('data-bs-target');
  //       scrollToTarget(targetId);
  //       activateTab(this);
  //     });
  //   });

  //   dropdownItems.forEach(item => {
  //     item.addEventListener('click', function (e) {
  //       e.preventDefault();
  //       const targetId = this.getAttribute('data-bs-target');
  //       scrollToTarget(targetId);
  //       const correspondingPill = document.querySelector(`.nav-link[data-bs-target="${targetId}"]`);
  //       if (correspondingPill) {
  //         activateTab(correspondingPill);
  //       }
  //     });
  //   });
  // });

  function is_mobile() {
    return $toggle.is(':visible');
  }


  // create focus trap
  const focus_trap = focusTrap.createFocusTrap($header.get(0), {
    onActivate() {
      $toggle.addClass('is-active');
      $menu.addClass('visible');
      $body.addClass('menu-open');
    },
    onDeactivate() {
      $toggle.removeClass('is-active');
      $body.removeClass('menu-open');
      setTimeout(function () {
        $menu.removeClass('visible');
      }, speed);
    },
    initialFocus: $toggle.get(0),
  });


  function resize() {
    $header.toggleClass('mobile', !ThemeJS.Media_Queries.is_at_least(menu_bp));
    document.querySelector(':root').style.setProperty('--header-height', `${$header.outerHeight()}px`);
    $menu.removeClass('mobile-transition-enabled');
    setTimeout(function () {
      $menu.addClass('mobile-transition-enabled');
    }, 0);
    if (ThemeJS.Media_Queries.is_at_least(menu_bp)) {
      focus_trap.deactivate();
      $('button.sub-menu-toggle').closest('li').each(function () {
        set_submenu_open($(this), false);
      });
    }
  }


  // init header pad height and set header to fixed
  resize();
  $header.addClass('fixed');
  // trigger height recalculation on breakpoint change
  $(window).on('breakpoint_changed', resize);

  // toggle mobile menu on hamburger click
  $toggle.click(() => {
    $body.hasClass('menu-open') ? focus_trap.deactivate() : focus_trap.activate();
  });


  // function to set submenus open/close
  function set_submenu_open($li, opening) {
    let $btn = $('> .link-wrap button.sub-menu-toggle', $li);
    if (!$btn.length) { return; }
    let $submenu = $(`#${$btn.attr('aria-controls')}`);
    if (!$submenu.length) { return; }
    $btn.attr('aria-expanded', opening ? 'true' : 'false');
    $submenu.attr('aria-hidden', opening ? 'false' : 'true')[opening ? 'slideDown' : 'slideUp'](speed);
  }


  // toggle submenus on click of caret btns
  $menu.on('click', 'button.sub-menu-toggle', function () {
    set_submenu_open($(this).closest('li'), $(this).attr('aria-expanded') == 'false');
  });


  // close submenu on tab out
  $menu.on('focusout', 'li.menu-item-has-children', function (e) {
    if (is_mobile() || $.contains(this, e.relatedTarget)) { return; }
    set_submenu_open($(this), false);
  });


  // treat click of a custom link '#' menu item as clicking its submenu toggle
  $menu.on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
    let $btn = $('+ .sub-menu-toggle', this);
    if ($btn.length) {
      $btn.click();
    }
  });

})(jQuery);
